<i18n>
{
  "fr": {
    "close": "fermer"
  }
}
</i18n>

<template>
  <transition :name="transitionName" appear v-on="transitionHooks">
    <div v-if="isActive" :class="className" class="base-modal">
      <slot name="backdrop">
        <div class="base-modal__backdrop" @click="backdropClose"></div>
      </slot>

      <div class="base-modal__container-wrapper">
        <div class="base-modal__container">
          <slot name="container">
            <div v-if="shouldDisplayHeader" class="base-modal__header">
              <slot name="header">
                <slot name="header-content">
                  <div
                    v-if="title || $slots['header-title']"
                    class="base-modal__header-title"
                  >
                    <slot name="header-title">
                      {{ title }}
                    </slot>
                  </div>
                </slot>

                <template v-if="!hideCloseButton">
                  <slot name="header-close-btn">
                    <button
                      :title="computedCloseLabel"
                      type="button"
                      class="base-modal__close-btn"
                      @click="close(false)"
                    >
                      <slot name="header-close-btn-label">
                        <span
                          v-if="computedCloseLabel"
                          class="base-modal__close-btn-label"
                        >
                          {{ computedCloseLabel }}
                        </span>
                      </slot>
                    </button>
                  </slot>
                </template>
              </slot>
            </div>

            <div
              v-if="$slots['subheader'] || $slots['subheader-content']"
              class="base-modal__subheader"
            >
              <slot name="subheader">
                <div class="base-modal__subheader-container">
                  <slot name="subheader-content"></slot>
                </div>
              </slot>
            </div>

            <div ref="body" class="base-modal__body">
              <slot name="body">
                <div class="base-modal__body-container">
                  <slot></slot>
                </div>
              </slot>
            </div>

            <div
              v-if="$slots['footer'] || $slots['footer-content']"
              class="base-modal__footer"
            >
              <slot name="footer">
                <div class="base-modal__footer-container">
                  <slot name="footer-content"></slot>
                </div>
              </slot>
            </div>

            <div
              v-if="
                $slots['actions'] ||
                $slots['action-container'] ||
                $slots['action-toolbar']
              "
              class="base-modal__actions"
            >
              <slot name="actions">
                <div class="base-modal__actions-container">
                  <slot name="actions-container">
                    <BtnToolbar centered v-bind="actionToolbarProps">
                      <slot name="action-toolbar"></slot>
                    </BtnToolbar>
                  </slot>
                </div>
              </slot>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Modal from '../mixins/Modal';
import BtnToolbar from './BtnToolbar';

const BLOCK_SELECTOR = 'base-modal';

export default {
  name: 'BaseModal',
  components: { BtnToolbar },
  mixins: [Modal],
  model: {
    prop: 'isActive',
    event: 'close',
  },
  props: {
    transitionName: {
      type: String,
      default: `${BLOCK_SELECTOR}-`,
    },
    fullScreen: { type: Boolean, default: false },
    // fullScreenUntilXxxs: { type: Boolean, default: false },
    // fullScreenUntilXxs: { type: Boolean, default: false },
    fullScreenUntilXs: { type: Boolean, default: false },
    // fullScreenUntilS: { type: Boolean, default: false },
    fullScreenUntilM: { type: Boolean, default: false },
    // fullScreenUntilL: { type: Boolean, default: false },
    // fullScreenUntilXl: { type: Boolean, default: false },
    // fullScreenUntilXxl: { type: Boolean, default: false },
    // fullScreenUntilXxxl: { type: Boolean, default: false },
    dockedRight: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    actionToolbarProps: {
      type: Object,
      default: null,
    },
    afterEnterCb: {
      type: Function,
      default: null,
    },
    afterLeaveCb: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      BLOCK_SELECTOR,
    };
  },
  computed: {
    /**
     *
     * @return {string}
     */
    computedCloseLabel() {
      return (
        (this.closeLabel && this.$t && this.$t(this.closeLabel)) ||
        this.closeLabel
      );
    },
    shouldDisplayHeader() {
      return (
        !this.hideCloseButton ||
        !!this.$slots['header'] ||
        !!this.$slots['header-content'] ||
        this.title ||
        !!this.$slots['header-title']
      );
    },
    className() {
      return {
        [`${BLOCK_SELECTOR}--full-screen`]: this.fullScreen,
        // [`${BLOCK_SELECTOR}--full-screen-until-xxxs`]: this.fullScreenUntilXxxs,
        // [`${BLOCK_SELECTOR}--full-screen-until-xxs`]: this.fullScreenUntilXxs,
        [`${BLOCK_SELECTOR}--full-screen-until-xs`]: this.fullScreenUntilXs,
        // [`${BLOCK_SELECTOR}--full-screen-until-s`]: this.fullScreenUntilS,
        [`${BLOCK_SELECTOR}--full-screen-until-m`]: this.fullScreenUntilM,
        // [`${BLOCK_SELECTOR}--full-screen-until-l`]: this.fullScreenUntilL,
        // [`${BLOCK_SELECTOR}--full-screen-until-xl`]: this.fullScreenUntilXl,
        // [`${BLOCK_SELECTOR}--full-screen-until-xxl`]: this.fullScreenUntilXxl,
        // [`${BLOCK_SELECTOR}--full-screen-until-xxxl`]: this.fullScreenUntilXxxl,
        [`${BLOCK_SELECTOR}--docked-right`]: this.dockedRight,
        [`${BLOCK_SELECTOR}--white`]: this.white,
      };
    },
    transitionHooks() {
      const hooks = {};

      ['afterEnter', 'afterLeave'].forEach(k => {
        if (this[`${k}Cb`]) {
          hooks[k] = this[`${k}Cb`];
        }
      });

      return hooks;
    },
  },
  methods: {
    backdropClose() {
      if (this.closeOnBackdropClick) {
        this.close(false);
      }
    },
  },
};
</script>
